<script lang="ts" setup>
  import { onMounted, ref } from 'vue'

  import WidgetSkeleton from '@/components/dashboard/WidgetSkeleton.vue'
  import type { EmployeeFavoriteJsonldDefaultRead } from '@/api' // import { useGeneratedWorktimeTrackingEntryStore } from '@/stores'
  import { useGeneratedEmployeeFavoriteStore } from '@/stores'
  import ButtonDefault from '@/elements/ButtonDefault.vue'

  import { ExternalLinkIcon } from '@/config/icons'

  const isLoading = ref(true)
  // const favorites = ref<EmployeeFavoriteJsonldDefaultRead[]>([])
  const favorites = computedAsync<EmployeeFavoriteJsonldDefaultRead[]>(
    async () =>
      useGeneratedEmployeeFavoriteStore()
        .findAll({ query: { linkedModel: 'dashboard' } })
        .then((d) => d.value),
    undefined
  )

  async function refresh() {
    isLoading.value = true
    isLoading.value = false
  }

  onMounted(async () => {
    await refresh()
  })

  //const btnClasses = 'flex-1 inline-flex items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-gray-300 hover:bg-gray-50 disabled:opacity-40'

  function resolveEnv(input: string): string {
    if (!input) return input

    // Regex, um __VARIABLE__-Platzhalter zu finden
    const regex = /__([A-Z0-9_]+)__/g

    return input.replace(regex, (_, varName) => {
      const key = `__${varName}__` as keyof typeof globalThis
      const globalValue = globalThis[key]

      return typeof globalValue === 'string' ? globalValue : `__${varName}__`
    })
  }
</script>

<i18n>
{
  "de": {
  }
}
</i18n>

<template>
  <div v-if="favorites?.length" class="@container">
    <WidgetSkeleton v-if="isLoading" variant="favorites" />

    <div v-else class="flex flex-wrap gap-x-2 gap-y-2" role="list">
      <template v-for="fav in favorites.filter(f => !!f.content)" :key="fav['@id']">
        <a
          :href="resolveEnv(fav.content!)"
          target="_blank"
          class="
            text-sm
            w-full
            @[380px]:w-auto">
          <ButtonDefault
            :icon="fav.icon ? fav.icon: ExternalLinkIcon"
            :severity="fav.severity ?? undefined"
            :label="fav.title"
            outlined
            icon-class="s-3"
            icon-pos="right"
            class="w-full"
            size="small"
          />
        </a>
        <!--        v-if="fav.content.includes('://')"-->
        <!--        <ButtonRouter
                  v-else
                  :label="fav.title"
                  :to="resolveEnv(fav.content)"
                  class="text-sm w-full @[380px]:w-auto"
                  icon-class="s-3"
                  icon-pos="right"
                  size="small" />-->
      </template>
    </div>
  </div>
</template>

<style scoped></style>
